import { useCheckAccountTraits } from '@cmg/auth';
import { TextInputField, ToastManager } from '@cmg/common';
import React, { useRef } from 'react';

import { useAIGeneratedFilters } from '../../hooks/useAIGeneratedFilters';
import { SFiltersRow } from './DatalabFilterForm';

export const AISearchField = () => {
  const textInputFieldRef = useRef<HTMLInputElement | null>(null);
  const hasAIPermission = useCheckAccountTraits(['PREMIUM_AI']);

  const { isLoading, generateFiltersFromQuery } = useAIGeneratedFilters(error => {
    // The filters are still using the ToastManager to show errors
    ToastManager.error(`Error generating filters from query: ${error.message}`);
  });

  if (!hasAIPermission) {
    return null;
  }

  return (
    <SFiltersRow>
      <TextInputField
        name="ai-query"
        ref={textInputFieldRef}
        placeholder="✨ Search offerings with plain text"
        label="Filter"
        disabled={isLoading}
        fullWidth
        onKeyDown={event => {
          if (event.key === 'Enter') {
            if (textInputFieldRef.current?.value) {
              generateFiltersFromQuery(textInputFieldRef.current?.value);
            }
          }
        }}
      />
    </SFiltersRow>
  );
};

export default AISearchField;
